import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { path: '/dashboard', label: 'Home', icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#AEAEB2'} strokeWidth="1.8">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H5a1 1 0 01-1-1V9.5z"/>
      <path d="M9 21V12h6v9"/>
    </svg>
  )},
  { path: '/send', label: 'Send', icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#AEAEB2'} strokeWidth="1.8">
      <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z"/>
    </svg>
  )},
  { path: '/buy', label: 'Add', icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#AEAEB2'} strokeWidth="1.8">
      <circle cx="12" cy="12" r="10"/>
      <path d="M12 8v8M8 12h8"/>
    </svg>
  )},
  { path: '/request', label: 'Request', icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#AEAEB2'} strokeWidth="1.8">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <path d="M2 10h20"/>
    </svg>
  )},
  { path: '/move', label: 'Move', icon: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#AEAEB2'} strokeWidth="1.8">
      <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/>
    </svg>
  )},
];

export default function BottomNav({ onMenuOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav style={s.nav}>
      {TABS.map(tab => {
        const active = location.pathname === tab.path;
        return (
          <button key={tab.path} style={s.tab} onClick={() => navigate(tab.path)}>
            <tab.icon active={active}/>
            <span style={{...s.label, color: active ? '#007AFF' : '#AEAEB2'}}>
              {tab.label}
            </span>
          </button>
        );
      })}
      <button style={s.tab} onClick={onMenuOpen}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#AEAEB2" strokeWidth="1.8">
          <line x1="3" y1="6" x2="21" y2="6"/>
          <line x1="3" y1="12" x2="21" y2="12"/>
          <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
        <span style={{...s.label, color:'#AEAEB2'}}>More</span>
      </button>
    </nav>
  );
}

const s = {
  nav:   {
    position:'fixed', bottom:0, left:0, right:0,
    background:'#fff',
    borderTop:'1px solid rgba(0,0,0,0.06)',
    display:'flex',
    width:'100%',
    padding:'8px 0 20px',
    zIndex:100,
    boxShadow:'0 -4px 20px rgba(0,0,0,0.06)'
  },
  tab:   {
    flex:1,
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    gap:3,
    background:'none',
    border:'none',
    cursor:'pointer',
    padding:'4px 0',
    minWidth:0
  },
  label: {fontSize:10, fontWeight:500}
};
